/**
 * @fileoverview プロパティリスト表示コンポーネント
 *
 * このファイルでは、複数のプロパティ（キー・値のペア）をリスト形式で
 * 表示するためのコンポーネントを定義しています。ユーザープロファイル情報や
 * 設定項目の一覧表示などに使用されます。
 */

/**
 * プロパティリストコンポーネント
 *
 * 複数のプロパティ（キー・値のペア）をリスト形式で表示します。
 * 一貫したレイアウトとスタイルで情報を整理し、閲覧性を高めます。
 * 各プロパティは内部でPropertyコンポーネントを使用して表示されます。
 *
 * @param {Object} props - コンポーネントのプロパティ
 * @param {Array<{label: string, value: React.ReactNode}>} props.properties - 表示するプロパティの配列
 * @param {string} [props.title] - プロパティリストのタイトル
 * @param {string} [props.className] - 追加のCSSクラス名
 * @returns {JSX.Element} プロパティリスト表示コンポーネント
 */
import { FC } from "react";
import { PropertyType, Property } from "@/components/property";

export type PropertyListType = PropertyType[];

type Props = {
  properties: PropertyListType;
};

export const PropertyList: FC<Props> = ({ properties }) => {
  return (
    <table className="w-full">
      {properties.map((property, i) => (
        <tr className="block p-4 border-solid border-b-2 last:border-0" key={i}>
          <Property property={property} />
        </tr>
      ))}
    </table>
  );
};
